<span class="small"> Paso {{ stepNumber }} de {{ totalSteps }}</span>
<h1 class="">
  {{ title }}
</h1>
<h2 *ngIf="subtitle" class="">
  {{ subtitle }}
</h2>
